/**
 * Deprecated blog slugs → logical SEO paths (301-style client redirect + firebase.json).
 * Content merged into hub pages to reduce cannibalization.
 */
export const BLOG_SLUG_REDIRECTS = {
  'prime-document-sign-encryption-firebase-google-cloud-security': '/trust',
  'how-audit-trails-work-esignature-software': '/trust',
  'is-it-safe-to-sign-documents-online': '/trust',
  'are-electronic-signatures-legally-binding': '/what-is-esignature',
  'how-to-create-legally-binding-agreement-electronic-signature': '/what-is-esignature',
  'prime-document-sign-youtube-social-media-official': '/reviews',
  'why-prime-document-sign-is-trusted-software': '/trust',
  'prime-document-sign-legal-esign-us-eu-au': '/trust',
  'prime-document-sign-audit-trails-explained': '/trust',
  'verify-prime-document-sign-australian-company-google': '/trust',
  'what-is-prime-document-sign-who-built-it': '/product',
  'prime-document-sign-client-data-trust': '/trust',
  'prime-document-sign-is-it-secure-and-trusted': '/trust',
  'prime-document-sign-google-business-trust-reviews': '/reviews',
  'electronic-signature-audit-trail-what-is-included': '/trust',
}
